// extracted by mini-css-extract-plugin
module.exports = {"row":"_3Me_OAoD94rss9i36aWjBD","card":"_2se7n56SkGpngB7mLSjloS","content":"_19P1k5PZMvVLC6RAJTm-pW","contentTitle":"YcOGGC1xvTRehl5cjukqZ"};